import type { LocalizableOption, Option } from '@/modules/shared/types';

export function localizeOptions(
	choices: LocalizableOption[],
	t: (key: string) => string,
): Option[];

export function localizeOptions<T extends readonly LocalizableOption[][]>(
	choicesArray: readonly [...T],
	t: (key: string) => string,
): { [K in keyof T]: Option[] };

export function localizeOptions(
	choices: LocalizableOption[] | readonly LocalizableOption[][],
	t: (key: string) => string,
): Option[] | Option[][] {
	const localize = (arr: LocalizableOption[]) =>
		arr.map(choice => ({
			label: t(choice.labelKey as never),
			value: choice.value,
		}));

	if (Array.isArray(choices[0])) {
		return (choices as readonly LocalizableOption[][]).map(localize);
	}

	return localize(choices as LocalizableOption[]);
}
